/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import L from "./Lang"
import BaseCom from "./BaseCom";
import VideoPlayer from "./VideoPlayer";

export default class VideoPlayerModal extends BaseCom {
    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.src && <VideoPlayer src={this.props.src} type={this.props.type} autoplay={this.props.autoplay} />}
                </Modal.Body>
            </Modal>
        );
    }
}